

import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { ChevronDown, ChevronRight, Trash2 } from 'lucide-react'
import { MonthlyCredit } from './credit-control'
import { formatCurrency } from '../../utils'
import { CreditItemsTable } from './CreditItemsTable'
import { formatMonthYear } from '@/utils/format'
import { FileManager } from '@/components/form/anexar'
import { useCurrentUser } from '@/features/auth/state/auth'


interface MonthlyRowProps {
  monthData: MonthlyCredit
  onUpdate: (updatedMonth: MonthlyCredit) => void
  onDelete: () => void
}

export function MonthlyRow({ monthData, onUpdate, onDelete }: MonthlyRowProps) {
  const [isExpanded, setIsExpanded] = useState(false)

  const [isModalOpen, setIsModalOpen] = useState<{
    open: boolean
    id: string | null
  }>({
    open: false,
    id: null
  })
  
  const user = useCurrentUser()
  
  const handlePaidChange = (checked: boolean) => {
    onUpdate({
      ...monthData,
      isPaid: checked
    })
  }
  const handleSituacaoChange = (checked: boolean) => {
    onUpdate({
      ...monthData,
      isSituacaoPerDComp: checked
    })
  }
  const handleModal = (id: string) => {
    setIsModalOpen({ open: true, id })
  }
  return (
    <>
      <div className="grid grid-cols-12 gap-4 items-center px-4 py-3 border-b hover:bg-muted/30 transition-colors">
        <div className="col-span-1">
          <Button variant="ghost" size="sm" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
          </Button>
        </div>

        <div className="col-span-2">
          <h4 className="font-medium">{formatMonthYear(monthData.month)}</h4>
        </div>

        <div className="col-span-2">
          <p className="text-sm">{formatCurrency(monthData.totalUsed)}</p>
        </div>

        <div className="col-span-2">
          <Checkbox
            id={`situacao-${monthData.month}`}
            checked={monthData.isSituacaoPerDComp || false}
            onCheckedChange={handleSituacaoChange}
            className="h-5 w-5"
          />
        </div>

        <div className="col-span-1">
          <Checkbox
            id={`paid-${monthData.month}`}
            checked={monthData.isPaid || false}
            onCheckedChange={handlePaidChange}
            className="h-5 w-5"
          />
        </div>

        <div className="col-span-4 flex items-center gap-3">
          {user?.typeUser === 'ADMIN' && (
            <Button
              onClick={() => handleModal(monthData.id)} // ⬅️ aqui era control.id
              className="bg-primary text-primary-foreground hover:bg-primary-hover"
            >
              Anexar
            </Button>
          )}

          <Button variant="destructive" size="sm" onClick={onDelete}>
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      </div>
      {isModalOpen.open && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg">
                <FileManager
                  id={isModalOpen.id || ''}
                  type={`credit`}
                  id_client={''}
                  id_apuracao={''}
                  id_apuracao_competencia={''}
                  onClose={() => setIsModalOpen({ open: false, id: null })}
                  id_product={''}
                />
              </div>
            </div>
      )}
      {isExpanded && (
        <div className="px-4 py-3 bg-muted/20 border-b">
          <div className="pl-7">
            <CreditItemsTable
              items={monthData.items}
              onItemsChange={items => {
                const totalUsed = items.reduce((sum, item) => sum + item.value, 0)
                onUpdate({
                  ...monthData,
                  items,
                  totalUsed
                })
              }}
            />
          </div>
        </div>
      )}
    </>
  )
}
